import { useMemo } from 'react';

interface AppleCalendarIconProps {
  className?: string;
  size?: number;
  date?: Date;
}

export const AppleCalendarIcon = ({
  className,
  size = 32,
  date: dateProp,
}: AppleCalendarIconProps) => {
  const { weekday, day } = useMemo(() => {
    const date = dateProp ?? new Date();
    const weekday = date
      .toLocaleDateString('en-US', { weekday: 'short' })
      .toUpperCase();
    const day = date.getDate().toString();
    return { weekday, day };
  }, [dateProp]);

  return (
    <div>
      <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0" y="0" width="100" height="100" rx="22" fill="#F5F5F5" />
        <text
          x="50"
          y="25"
          fontSize="14"
          fontWeight="500"
          fill="#FF3B30"
          textAnchor="middle"
          fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        >
          {weekday}
        </text>
        <text
          x="50"
          y="78"
          fontSize="48"
          fontWeight="400"
          fill="#000000"
          textAnchor="middle"
          fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        >
          {day}
        </text>
      </svg>
    </div>
  );
};
